import AllRoutes from "./components/AllRoutes";


function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
